/**
 * Overview & Dashboard Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines overview and dashboard routes that sit in the main app shell.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS, USER_ROLES } from 'navigation/constants';

import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

const Overview = lazy(() => import('@/features/overview/view/overview-page'));
const DashboardPage = lazy(() => import('@/features/overview/view/overview-page'));
const NotificationsPage = lazy(() => import('@/features/notifications/view/notifications-page'));

export const dashboardRoutes: RouteGroup = {
  name: 'dashboard',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: true,
  },
  routes: [
    {
      path: ROUTE_PATHS.OVERVIEW,
      component: Overview,
      meta: {
        title: 'common:nav.overview',
        icon: 'HomeIcon',
        showInNav: true,
        navOrder: 1,
      },
    },
    {
      path: ROUTE_PATHS.DASHBOARD,
      component: DashboardPage,
      permission: {
        allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
      },
      meta: {
        title: 'common:nav.dashboard',
        icon: 'ChartBarIcon',
        showInNav: true,
        navOrder: 2,
      },
    },
    {
      path: ROUTE_PATHS.NOTIFICATIONS,
      component: NotificationsPage,
    },
  ],
};
